import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import MarqueeStrip from './components/MarqueeStrip';
import ManifiestoSection from './components/ManifiestoSection';
import GaleriaSection from './components/GaleriaSection';
import CatalogoSection from './components/CatalogoSection';
import B2BSection from './components/B2BSection';
import FAQSection from './components/FAQSection';
import FooterSection from './components/FooterSection';
import CartSidebar from './components/CartSidebar';
import FloatingCartButton from './components/FloatingCartButton';

const WHATSAPP_NUMBER = '34690808995';

function MainPage() {
  const [cart, setCart] = useState({});
  const [cartOpen, setCartOpen] = useState(false);

  const addToCart = (product) => {
    setCart(prev => ({
      ...prev,
      [product.id]: {
        ...product,
        quantity: (prev[product.id]?.quantity || 0) + 1,
      },
    }));
  };

  const removeFromCart = (productId) => {
    setCart(prev => {
      const newCart = { ...prev };
      if (newCart[productId]) {
        if (newCart[productId].quantity > 1) {
          newCart[productId] = { ...newCart[productId], quantity: newCart[productId].quantity - 1 };
        } else {
          delete newCart[productId];
        }
      }
      return newCart;
    });
  };

  const clearCart = () => setCart({});

  const cartItems = Object.values(cart);
  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const cartTotal = cartItems.reduce((sum, item) => sum + item.quantity * item.price, 0);

  const sendWhatsApp = () => {
    if (cartItems.length === 0) return;
    let message = '¡Hola María! Quería hacer un pedido:\n';
    cartItems.forEach(item => {
      message += `- ${item.quantity} x ${item.name}\n`;
    });
    message += `Total aprox: ${cartTotal.toFixed(2)}€. ¿Para cuándo podrías tenerlo?`;
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <>
      <Navbar cartCount={cartCount} onCartOpen={() => setCartOpen(true)} />
      <main>
        <HeroSection />
        <MarqueeStrip />
        <ManifiestoSection />
        <GaleriaSection />
        <CatalogoSection cart={cart} onAdd={addToCart} onRemove={removeFromCart} />
        <B2BSection />
        <FAQSection />
        <FooterSection />
      </main>
      <CartSidebar
        isOpen={cartOpen}
        onClose={() => setCartOpen(false)}
        cartItems={cartItems}
        cartTotal={cartTotal}
        onAdd={addToCart}
        onRemove={removeFromCart}
        onClear={clearCart}
        onSendWhatsApp={sendWhatsApp}
      />
      <FloatingCartButton
        cartCount={cartCount}
        onOpen={() => setCartOpen(true)}
        onSendWhatsApp={sendWhatsApp}
      />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
